import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  // 正式环境去掉conosle
  window.console.log = function () { };
  window.console.info = function () { };
  window.console.error = function () { };
  window.console.debug = function () { };
  enableProdMode();
} else {
  console.log('测试环境');
}

platformBrowserDynamic().bootstrapModule(AppModule
)
  .catch(err => console.log(err));



// WEBPACK FOOTER //
// E:/project/muyiwang/svn/project-code/trad-portal/src/main.ts